import { FC } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

interface Props {
  source: object;
  className?: string;
}

export const Animation: FC<Props> = ({ source, className }) => {
  return <Player autoplay loop className={className} src={source}></Player>;
};
